import {
  Badge,
  Col,
  Descriptions,
  Modal,
  Spin,
  Card,
  Popconfirm,
  Button,
} from "antd";
import profilePic from "../../../src/assets/images/profilepic.png";
import OrderStatusTimeline from "../NewComponents/OrderStatusTimeLine";
import Title from "antd/lib/typography/Title";
import React, { useState, useEffect, useRef, Fragment } from "react";
import FormSelect from "../general/FormSelect";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import { useSelector } from "react-redux";
import { postRequest } from "../../services/mainApp.service";
import { submitForm } from "../../redux/actions/basicFormAction";
import CustomButton from "../NewComponents/CustomButton";
import { getOrderStatuses } from "../../utils/OrderPageFunctions";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import RiderSelectModal from "./RiderSelectModal";
import OrderTransfer from "./OrderTransfer";
import {
  CheckCircle,
  Clock,
  MapPin,
  History,
  Phone,
  Truck,
  User,
  X,
  Package,
  Building,
  Navigation,
  BadgeDollarSign,
  Receipt,
  Calendar,
  DollarSign,
  Copy,
  Clipboard,
  Files,
  PhoneCall,
  ShoppingCart,
  EyeIcon
} from "lucide-react";

import ygen from "../../assets/images/ygen.png";
const controller = new window.AbortController();
import axios from "axios";
import { message } from "antd";
import ReceiptPrint from "../NewComponents/SalesReceipt";
import PreviousOrders from "../NewComponents/PreviousOrders";
import DeliveryTimeCounter from "../NewComponents/DeliveryTimeCounter";

const copyToClipboard = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      message.success("Copied to clipboard: " + text);
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};

const ViewOrderModal = (props) => {
  let {
    viewOrder,
    data,
    toggleViewOrder,
    isMainPage,
    onUpdateOrders,
    ridersData,
    branchList,
    fetchLatestOrders = () => { },
  } = props;

  const {
    OrderMasterId,
    AreaId,
    OrderSourceId,
    AreaName,
    OrderNumber,
    OrderDate,
  } = data?.Table[0] || {};
  const controller = new window.AbortController();
  const [isStatusChange, setIsStatusChange] = useState(false);

  

  // order transfer into another branch
  const [isBranchModalOpen, setIsBranchModalOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);

  // riders states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRider, setSelectedRider] = useState(null);

  const [orderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);

  const pendingOrderStatusId = orderStatusList?.find(
    (status) => status.OrderStatus === "Pending"
  )?.OrderStatusId;
  const orderStatusId = data?.Table[0]?.OrderStatusId || null;
  const ispendingOrder = orderStatusId === pendingOrderStatusId;

  const DateRefFrom = useRef({});
  const DateRefTo = useRef({});
  const [supportingTable, setSupportingTable] = useState();
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [orderItemsDetail, setOrderItemsDetail] = useState([]);

  const { formFields, itemList, formLoading, tableLoading } = useSelector(
    (state) => state.basicFormReducer
  );
  const userData = useSelector((state) => state.authReducer);
  const { userBranchList } = useSelector((state) => state.authReducer);

  const { acceptStatus, cancelStatus } = getOrderStatuses(orderStatusList);

  const handleRiderSelection = (selectedRider) => {
  
  };

  const [orderItems, setOrderItems] = useState([]);

  useEffect(() => {
    const riderName = data?.Table[0]?.RiderName;
    const branchName = data?.Table[0]?.BranchName;
    setSelectedRider(riderName);
    setSelectedBranch(branchName);
  }, [data]);

  function organizeOrderItems(items) {
    // First get all parent items (DealItemId is null)
    const parentItems = items.filter((item) => item.DealItemId === null);

    const result = [];

    for (const parent of parentItems) {
      // Find children - same RandomId AND DealItemId is NOT null AND not the parent itself
      const children = items.filter(
        (item) => item.RandomId === parent.RandomId && item.DealItemId !== null
      );

      result.push({
        parent,
        children,
      });
    }

    return result;
  }

  const filteredData = organizeOrderItems(data?.Table1 || []);
  const totalItemsCount = filteredData.reduce((total, item) => {
    return total + (item.children.length > 0 ? item.children.length : 1);
  }, 0);

  const initialFormValues = {
    BranchId: null,
    AreaId: null,
    OrderNumber: "",
    CustomerId: null,
    CustomerName: "",
    CustomerPhone: "",
    OrderModeId: null,
    OrderSourceId: null,
    DateFrom: "",
    DateTo: "",
    StatusId: null,
    CityId: null,
  };

  const fetchDataFromApi = () => {
    postRequest("GetOrder", {
      OperationId: 1,
      UserIP: "12.1.1.2",
      BranchId:
        selectedOrder?.BranchId ||
          (userBranchList && userBranchList.length === 1)
          ? userBranchList[0].BranchId
          : null,
      DateFrom: "2022-01-13 00:00:00.000",
      DateTo: "2023-11-13 00:00:00.000",
      CityId: userBranchList && userBranchList[0]?.CityId,
      CompanyId: userData.CompanyId,
      userId: userData?.userId,
      userData: data?.Table || [],
    })
      .then((response) => {
        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }

        const data = response.data.DataSet;
      
        const { Table2 } = data;

        // Populate your dropdown lists based on the data
        setOrderStatusList(Table2 || []);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleStatusChange = async (data) => {
    setOrderStatus(data.value);

    if (data.value !== null) {
      var finalDate = DateRefFrom.current;
      var finalDateTo = DateRefTo.current;

      if (+finalDate === +new Date() && +finalDateTo === +new Date()) {
        finalDate =
          finalDate.getFullYear() +
          "-" +
          (finalDate.getMonth() + 1) +
          "-" +
          finalDate.getDate() +
          " " +
          "00:00:00.000";

        finalDateTo =
          finalDateTo.getFullYear() +
          "-" +
          (finalDateTo.getMonth() + 1) +
          "-" +
          finalDateTo.getDate() +
          " " +
          "00:00:00.000";
      }

      try {
        const response = await axios.post("/UpdateOrderStatus", {
          OperationId: 2,
          OrderMasterId,
          CompanyId: userData?.CompanyId,
          OrderStatusId: data.value,
          DateFrom: "2022-01-13 00:00:00.000",
          DateTo: "2023-11-13 00:00:00.000",
          userId: userData?.UserId,
          AreaId,
          OrderSourceId,
          AreaName,
          OrderNumber,
          OrderDate,
        });
    
        const { DataSet } = response.data;
        if (DataSet && DataSet.Table) {
          const { HasError, Error_Message, Message, Id } = DataSet.Table[0];

          if (HasError === 1) {
            
          } else {
           
          }
        }

        if (DataSet && DataSet.Table1) {
          fetchLatestOrders();
          const orderMas = DataSet.Table1.find((item) => {
           
            return data.OrderMasterId === item.OrderMasterId;
          });

          setSelectedOrder(orderMas);
        }

        if (DataSet && DataSet.Table2) {
          const orderItems = DataSet.Table2.filter((item) => {
            return data.OrderMasterId === item.OrderMasterId;
          });

          setFilteredOrders([...orderItems]);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handleCombinedChange = (event) => {
    handleStatusChange(event);
    toggleViewOrder();
  };

  // handle status change
  const handleStatusChange2 = async (orderStatusId, orderDetials) => {
    toggleViewOrder();
    if (!orderDetials?.OrderMasterId) return;

    try {
      const response = await postRequest("/UpdateOrderStatus", {
        OperationId: 2,
        OrderMasterId: orderDetials?.OrderMasterId,
        CompanyId: userData?.CompanyId,
        OrderStatusId: orderStatusId,
        DateFrom: "2022-01-13 00:00:00.000",
        DateTo: "2023-11-13 00:00:00.000",
        userId: userData?.UserId,
        AreaId: orderDetials?.AreaId,
        OrderSourceId: orderDetials?.OrderSourceId,
        AreaName: orderDetials?.AreaName,
        OrderNumber: orderDetials?.OrderNumber,
        OrderDate: orderDetials?.OrderDate,
      });

      const data = response?.data?.DataSet;
      const { Table6 } = data;
      onUpdateOrders(Table6);
      // toggleViewOrder();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchDataFromApi();
  }, [userBranchList]);

  return (
    <Modal
      visible={viewOrder}
      onCancel={toggleViewOrder}
      destroyOnClose={true}
      footer={null}
      width={"80%"}
      afterClose={() => {
        setIsStatusChange(false);
      }}
      style={{ top: 10 }} // Set top offset
      className="rounded-xl "
    >
      <Spin spinning={data === null}>
        <div className="">
          {/* header of order */}
          <div className="flex justify-between items-center leading-tight border-b pb-2">
            <div className=" flex flex-row justify-between w-full items-end">
              {/* <span className=" text-[16px] text-gray-500">Order #{data?.Table[0]?.OrderNumber.substring(data?.Table[0]?.OrderNumber.lastIndexOf("/") + 1) || "N/A"}</span> */}



              <div className="flex items-end">
                <div className="flex flex-col">
                  <span className="text-gray-700 text-2xl px-2 flex gap-2 items-center leading-tight">

                    Order&nbsp;
                    {data?.Table[0]?.OrderNumber
                      .substring(
                        data?.Table[0]?.OrderNumber.lastIndexOf("/") + 1
                      )
                      || "N/A"}
                  </span>
                  <span className="px-2 text-base flex gap-4 text-gray-500">
                    <div className="flex  gap-2 mb-0.5">
                      <span className="leading-tight text-[16px] flex items-center gap-1">
                        Placed on <Calendar className="w-4 h-4" />{" "}
                        <span className="">
                          {data?.Table[0]?.OrderDate?.split(" ")[0]}
                        </span>
                      </span>
                      <span className="leading-tight text-[16px] flex items-center gap-1">
                        at <Clock className="w-4 h-4" />{" "}
                        <span className="">
                          {data?.Table[0]?.OrderDate?.split(" ")[1]}
                        </span>
                      </span>
                    </div>
                  </span>
                </div>
              </div>

              <ReceiptPrint
                orderDetails={data?.Table[0]}
                orderItems={data?.Table1}
              />
            </div>

            <div className="">

              {isMainPage && !ispendingOrder ? (
                <Col className="mr-10 w-full">
                  {/* <div style={{ display: "flex", alignSelf: "flex-start" }}>
                  Status
                </div> */}
                  <FormSelect
                    colSpan={24}
                    listItem={orderStatusList?.filter(
                      (status) => status.OrderStatus !== "Pending"
                    )}
                    label="Status"
                    idName="OrderStatusId"
                    valueName="OrderStatus"
                    size={"large"}
                    name="OrderStatusId"
                    value={
                      isStatusChange
                        ? orderStatus
                        : data?.Table[0].OrderStatusId || ""
                    }
                    onChange={handleCombinedChange}
                    className="mr-10 rounded-lg"
                  />
                </Col>
              ) : (
                <div className="flex justify-end gap-2 mr-14 ">
                  <Popconfirm
                    title="Are you sure to Cancel this Order?"
                    onConfirm={() =>
                      handleStatusChange2(
                        cancelStatus?.OrderStatusId,
                        data?.Table[0]
                      )
                    }
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{
                      style: {
                        backgroundColor: "#52c41a",
                        borderColor: "#52c41a",
                        color: "white",
                      },
                    }} // Green color for Yes
                    cancelButtonProps={{
                      style: {
                        backgroundColor: "#ff4d4f",
                        borderColor: "#ff4d4f",
                        color: "white",
                      },
                    }} // Red color for No
                  >
                    {/* <CustomButton
                    type="danger"
                    text="Cancel"
                    icon={<CloseOutlined className="text-red-600"/>}
                    className="py-4"
                    // onClick={() =>
                    //   handleStatusChange2(
                    //     cancelStatus?.OrderStatusId,
                    //     data?.Table[0]
                    //   )
                    // }
                    // loading={loadingButtons[record.OrderMasterId]}
                    style={{
                      // backgroundColor: "#F44336",
                      width: "200px",
                      color: "black",
                      border: "1px solid #000000",
                    }} */}
                    {/* /> */}

                    <button className="flex justify-center items-center bg-gray-white gap-3 hover:bg-red-600 hover:text-white  border bg-white x-2 py-3 rounded-lg min-w-[150px]">
                      <CloseOutlined className="" />
                      <span className="font-semibold">Cancel Order</span>
                    </button>
                  </Popconfirm>

                  <Popconfirm
                    title="Are you sure to Accept this Order?"
                    onConfirm={() =>
                      handleStatusChange2(
                        acceptStatus?.OrderStatusId,
                        data?.Table[0]
                      )
                    }
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{
                      style: {
                        backgroundColor: "#52c41a",
                        borderColor: "#52c41a",
                        color: "white",
                      },
                    }} // Green color for Yes
                    cancelButtonProps={{
                      style: {
                        backgroundColor: "#ff4d4f",
                        borderColor: "#ff4d4f",
                        color: "white",
                      },
                    }} // Red color for No
                  >
                    {/* <CustomButton
                      type="primary"
                      text="Accept"
                      icon={<CheckOutlined />}
                      className="py-4"
                      // onClick={() =>
                      //   handleStatusChange2(
                      //     acceptStatus?.OrderStatusId,
                      //     data?.Table[0]
                      //   )
                      // }
                      // loading={loadingButtons[record.OrderMasterId]}
                      style={{
                        backgroundColor: "#059669",
                        width: "200px",
                      }}
                    /> */}

                    <button className="flex justify-center items-center gap-3 bg-[#16A34A] hover:bg-green-700 text-white px-2 py-3 rounded-lg min-w-[150px]">
                      <CheckOutlined className="font-semibold" />
                      <span className="font-semibold">Accept Order</span>
                    </button>
                  </Popconfirm>
                </div>
              )}
            </div>
          </div>

          {/* top row */}
          <div className="mt-8 w-full flex justify-between  gap-4  rounded-lg  ">
            {/* customer information */}

            <div className="ml-2      w-[28%] ">
              <div className="border rounded-xl p-4">
                <div className="flex flex-col items-center  mb-2  border-gray-100">
                  <div className=" h-28 w-28 rounded-full   border-gray-100 text-3xl flex items-center justify-center text-gray-700  font-semibold">
                    <img
                      src={profilePic}
                      alt="Profile"
                      className="object-cover rounded-full"
                    />
                  </div>

                  <h1 className="text-2xl font-bold text-gray-800 flex items-center ">
                    {data?.Table[0]?.CustomerName}
                  </h1>

                  <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-white border-0 px-3 py-0.5 rounded-full text-sm font-semibold">
                    {data?.Table[0]?.PreviousOrderCount > 0
                      ? <div className='flex items-center gap-1'> <History className="w-4 h-4" /> {`Previous Orders: ${data?.Table[0]?.PreviousOrderCount}`}</div>
                      : "⭐ New Customer"}
                  </span>


                </div>

                <div className="rounded-xl  p-5 mt-4  bg-gray-50">
                  <div className="text-sm divide-y divide-gray-100">
                    {/* Mobile */}
                    {data?.Table[0]?.PhoneNumber && (
                      <div className="flex flex-col py-1">
                        <span className="text-gray-500 w-40 font-medium shrink-0 text-[15px] flex gap-2">
                          {/* <PhoneCall className="w-5 h-5 text-blue-500"/>  */}
                          Contact:
                        </span>
                        <span className="text-black flex-1 flex items-center gap-2 break-words text-lg">
                          {data?.Table[0]?.PhoneNumber}
                          <button
                            onClick={() =>
                              copyToClipboard(data?.Table[0]?.PhoneNumber)
                            }
                            className="text-blue-500 hover:text-blue-700"
                          >
                            <Files width={18} height={18} />
                          </button>
                        </span>
                      </div>
                    )}

                    {/* Alternative Phone */}
                    {data?.Table[0]?.AlternateNumber && (
                      <div className="flex flex-col py-1">
                        <span className="text-gray-500 w-40 font-medium shrink-0 text-[15px]">
                          Alternative Phone:
                        </span>
                        <span className="text-black flex-1 break-words text-lg">
                          {data?.Table[0]?.AlternateNumber}
                        </span>
                      </div>
                    )}

                    {/* Area Name */}
                    {data?.Table[0]?.AreaName && (
                      <div className="flex flex-col py-1">
                        <span className="text-gray-500 w-40 font-medium shrink-0 text-[15px]">
                          Area Name:
                        </span>
                        <span className="text-black flex-1 break-words text-lg">
                          {data?.Table[0]?.AreaName}
                        </span>
                      </div>
                    )}

                    {/* Branch Name */}
                    {data?.Table[0]?.BranchName && (
                      <div className="flex flex-col py-1">
                        <span className="text-gray-500 w-40 font-medium shrink-0 text-[15px]">
                          Branch Name:
                        </span>
                        <span className="text-black flex-1 break-words text-[15px]">
                          {data?.Table[0]?.BranchName}
                        </span>
                      </div>
                    )}

                    {/* City Name */}
                    {data?.Table[0]?.CityName && (
                      <div className="flex py-1">
                        <span className="text-gray-500 w-40 font-medium shrink-0 text-[15px]">
                          City Name:
                        </span>
                        <span className="text-black flex-1 break-words text-[15px]">
                          {data?.Table[0]?.CityName}
                        </span>
                      </div>
                    )}

                    {/* Land Mark */}
                    {data?.Table[0]?.LandMark && (
                      <div className="flex py-1">
                        <span className="text-gray-500 w-40 font-medium shrink-0 text-[15px]">
                          Land Mark:
                        </span>
                        <span className="text-black flex-1 break-words text-[15px]">
                          {data?.Table[0]?.LandMark}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Delivery Address */}
                {data?.Table[0]?.CompleteAddress && (
                  <div className="border border-blue-100 bg-blue-50 rounded-xl p-4 mt-1">
                    <span className="text-blue-600 flex  gap-2 font-medium">
                      <MapPin className="h-5 w-5 text-blue-600" />
                      <span>Delivery Address</span>
                    </span>
                    <span className=" text-lg text-gray-700 leading-tight flex items-center gap-2 mt-1 break-words">
                      {data?.Table[0]?.CompleteAddress}
                      <button
                        onClick={() =>
                          copyToClipboard(data?.Table[0]?.CompleteAddress)
                        }
                        className="text-blue-500 hover:text-blue-700"
                      >
                        <Files width={18} height={18} />
                      </button>
                    </span>
                  </div>
                )}

              </div>
            </div>

            <div className=" rounded-xl     w-[44%] flex flex-col gap-2">
              {/* Order Information */}
              <div className="w-full rounded-xl border p-4  ">
                <h2 className="text-xl font-bold mb-1 text-gray-700">
                  Order Information
                </h2>

                <div className="grid grid-cols-3 gap-y-3 gap-x-6 text-sm  p-4 text-gray-700">


                  <div className="border-r">
                    <p className="text-gray-500">Order Mode</p>
                    <p className="font-medium text-lg">
                      {data?.Table[0]?.OrderMode}
                    </p>
                  </div>

                  <div className="border-r">
                    <p className="text-gray-500">Order Source</p>
                    <p className="font-medium text-lg">
                      {data?.Table[0]?.OrderSourceValue}
                    </p>
                  </div>

                  <div>
                    <p className="text-gray-500">Change Amount</p>
                    <p className="font-medium text-green-600 text-lg">
                      {data?.Table[0]?.ChangeAmount}
                    </p>
                  </div>
                </div>
                {data?.Table[0]?.Remarks1 && (
                  <div className="w-full mt-2 mb-1 bg-amber-50 border border-amber-200 rounded-md p-3 text-amber-800">
                    <div className="font-medium mb-1">
                      Special Instructions:
                    </div>
                    <div className="text-sm">{data?.Table[0]?.Remarks1}</div>
                  </div>
                )}
              </div>



              {/* order summary */}
              <div className=" w-full  rounded-xl border p-4  mt-2 ">
                <div className="">
                  <div className="flex justify-between items-center  mb-2 ">
                    <div className="flex gap-2 items-center">
                      <ShoppingCart />
                      <h3 className=" text-gray-900 text-lg font font-semibold">
                        Order Items
                      </h3>
                    </div>

                    <p className="text-sm bg-red-500 text-white px-2 rounded-md">
                      {totalItemsCount}{" "} Items
                    </p>
                  </div>

                  <div className="max-h-[380px] overflow-y-auto pr-2 space-y-2">
                    {filteredData?.map((group, groupIndex) => (
                      <div
                        key={groupIndex}
                        className="py-2 px-2 bg-gray-50 border-b  rounded-lg"
                      >
                        {/* Parent Item */}
                        <div className="flex items-center gap-3 px-2">


                          {/* Info */}
                          <div className="min-w-0 flex-1 ">
                            <div className="flex justify-between items-center">
                              <div className="text-base font-semibold text-black">
                                {group.parent.ProductName}{" "}
                                {group.parent.SizeName}{" "}
                                {group.parent.FlavourName}
                              </div>
                              <div className="text-base text-black text-right min-w-[80px]">
                                Rs.{" "}
                                {group.parent.PriceWithGST?.toLocaleString()}
                              </div>
                            </div>
                            <div className="flex gap-2 flex-wrap items-center text-sm text-black">
                              {group.parent.RemoteId && (
                                <span className="text-blue-700 bg-blue-50 px-2 py-0.5 rounded-md border border-blue-100">
                                  POS: {group.parent.RemoteId}
                                </span>
                              )}

                              <span className="text-green-700 bg-green-50 px-2 py-0.5 rounded-md border border-green-100">
                                Quantity: {group.parent.Quantity}
                              </span>
                              {group.parent.DiscountPercent > 0 && (
                                <>
                                  <span className="bg-rose-50 text-rose-600 border border-rose-100 rounded-md px-2 py-0.5">
                                    {group.parent.DiscountPercent}% OFF
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Child Items (if any) */}
                        {group.children?.length > 0 && (
                          <div className="mt-2 space-y-2 ml-8">
                            {group.children.map((child, childIndex) => (
                              <div
                                key={childIndex}
                                className="flex items-center gap-3 text-sm text-gray-700"
                              >
                                {/* <div className="h-9 w-9 rounded-md overflow-hidden shrink-0">
                                  <img
                                    src={
                                      child.ProductImage
                                        ? process.env.REACT_APP_BASEURL + child.ProductImage
                                        : ygen
                                    }
                                    alt=""
                                    className="object-cover h-full w-full"
                                  />
                                </div> */}
                                <div className="flex-1">
                                  <div className="flex justify-between items-center">
                                    <div className="font-medium">
                                      {child.ProductName} {child.SizeName}{" "}
                                      {child.FlavourName}
                                    </div>
                                    <div className="text-right min-w-[60px]">
                                      + Rs.{" "}
                                      {child.PriceWithGST?.toLocaleString()}
                                    </div>
                                  </div>
                                  <div className="text-xs text-gray-500 flex gap-1 flex-wrap">
                                    {child.RemoteId && (
                                      <span>
                                        POS: {child.RemoteId} &nbsp; Qty:{" "}
                                        {child.Quantity}
                                      </span>
                                    )}
                                    {child.DiscountPercent > 0 && (
                                      <span className="text-rose-600">
                                        {child.DiscountPercent}% OFF
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>


              {/* rider and delivery time */}
              <div className="flex justify-between border bg-gray-50 rounded-xl p-4 gap-4 mt-2">

                {/* Assign rider*/}
                {isMainPage && (
                  <div className=" flex-1 gap-4">
                    {/* Rider Assignment Card */}
                    <div className=" bg-white rounded-lg flex gap-2 flex-col items-center justify-between overflow-hidden p-3">
                     
                     {selectedRider && (
<div className="flex items-center justify-center  flex-col">
                        <span className="text-gray-900 text-2xl font-bold">
                          {selectedRider}
                        </span>
                        <span className="text-sm font-medium text-gray-700">
                          Assigned Rider
                        </span>
                      </div>
                     )}
                      

                      <div className="">
                        {isMainPage && (
                          <button
                            className="bg-blue-500 text-white px-4 py-2 rounded-lg flex items-center gap-2"
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                          >
                            <Truck className="h-5 w-5 text-gray-100 " />
                            {selectedRider ? "Change Rider" : "Assign Rider"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}



                {/* transfer branch*/}
                {!isMainPage && (
                  <div className="w-full flex gap-4">
                    {/* Rider Assignment Card */}
                    <div className="w-full bg-white rounded-xl flex flex-col items-center justify-between border border-gray-200 overflow-hidden p-4">
                      <div className="flex flex-col">
                        <span className="text-sm font-medium text-gray-700">
                          Branch
                        </span>
                        <span className="text-gray-900 text-2xl font-semibold">
                          {selectedBranch}
                        </span>
                      </div>

                      <div className="">
                        {!isMainPage && (
                          <button
                            className="bg-blue-500 text-white px-4 py-2 rounded-lg flex gap-2 items-center"
                            onClick={() => {
                              setIsBranchModalOpen(true);
                            }}
                          >

                            Transfer Into Other Branch
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                
                  <DeliveryTimeCounter
                    key={data?.Table[0]?.DeliveryTimeInMinutes}
                    initialMinutes={data?.Table[0]?.DeliveryTimeInMinutes}
                    record={data?.Table[0]}
                    userData={userData}
                  />
              

              </div>
            </div>

            <div className="w-[28%] ">
              {/* order status timeline */}
              <div className="max-w-3xl mx-auto border  rounded-2xl ">
                <OrderStatusTimeline logs={data?.Table3} key={data?.Table[0]?.OrderMasterId} />
              </div>

              {/* payment details */}
              <div className=" bg-gray-800 text-white rounded-xl  mt-4 shadow-md">
                <div className="w-full rounded-t-md py-2 flex items-center  px-4 ">
                  <BadgeDollarSign className="h-6 w-6 text-gray-300 mr-2" />
                  <h3 className="font-semibold text-lg text-white">
                    Payment Summary
                  </h3>
                </div>

                <div className="text-sm p-3">
                  <div className="flex justify-between">
                    <span className="text-gray-300 text-[16px] leading-tight">
                      Gross:
                    </span>
                    <span className="text-[16px] leading-tight">
                      Rs. {data?.Table[0]?.Gross?.toLocaleString() || "N/A"}
                    </span>
                  </div>

                  {data?.Table[0]?.Tip > 0 && (
                    <div className="flex justify-between">
                      <span className="text-gray-300 text-[16px] leading-tight">
                        Tip:
                      </span>
                      <span className="text-[16px] leading-tight">
                        Rs. {data?.Table[0]?.Tip?.toLocaleString() || "N/A"}
                      </span>
                    </div>
                  )}

                  <div className="flex justify-between">
                    <span className="text-gray-300 leading-tight text-[16px]">
                      Tax:
                    </span>
                    <span className="text-[16px] leading-tight">
                      Rs. {data?.Table[0]?.Tax?.toLocaleString() || "N/A"}
                    </span>
                  </div>

                  {data?.Table[0]?.Discount > 0 && (
                    <div className="flex justify-between">
                      <span className="text-gray-300 text-[16px] leading-tight">
                        Discount:
                      </span>
                      <span className="text-rose-600 text-[16px] leading-tight">
                        -Rs. {data?.Table[0]?.Discount?.toLocaleString()}
                      </span>
                    </div>
                  )}

                  <div className="flex justify-between">
                    <span className="text-gray-300 text-[16px] leading-tight">
                      Delivery Charges:
                    </span>
                    <span className="text-[16px] leading-tight">
                      Rs.{" "}
                      {data?.Table[0]?.DeliveryCharges?.toLocaleString() ||
                        "N/A"}
                    </span>
                  </div>

                  <div className="border-t border-gray-200 border-dashed my-1 pt-1"></div>

                  <div className="flex items-end justify-between font-semibold text-base">
                    <span className="text-[20px]">Total:</span>
                    <span className="text-emerald-600 text-2xl font-bold">
                      Rs. {data?.Table[0]?.NetAmount?.toLocaleString() || "N/A"}
                    </span>
                  </div>

                  {data?.Table[0]?.PaymentMode && (
                    <div className="flex justify-between border-t mt-2 pt-2">
                      <span>Payment Method</span>
                      <span className="font-semibold px-3 rounded-full bg-gray-100 text-black">
                        {data?.Table[0]?.PaymentMode || "N/A"}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Show Previous Order */}
              <div>
                {
                  data?.Table[0]?.PreviousOrderCount > 0 && (
                    <PreviousOrders userData={userData} record={data?.Table[0]} key={data?.Table[0]?.OrderMasterId} />
                  )
                }
              </div>
            </div>

          </div>



          {/* Assign Rider  */}
          <div className="flex-1 flex  justify-between gap-2 rounded-lg   px-4 py-2">
            <div className="  rounded-md flex justify-between items-center mb-4">
              <div className="w-full flex flex-col gap-2">
                <RiderSelectModal
                  riders={ridersData?.Table14}
                  onRiderSelect={handleRiderSelection}
                  isModalOpen={isModalOpen}
                  setIsModalOpen={setIsModalOpen}
                  orderDetials={data?.Table[0]}
                  setSelectedRider={setSelectedRider}
                />

                <OrderTransfer
                  branchesList={branchList}
                  orderDetials={data?.Table[0]}
                  isBranchModalOpen={isBranchModalOpen}
                  setIsBranchModalOpen={setIsBranchModalOpen}
                  setSelectedBranch={setSelectedBranch}
                />
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default ViewOrderModal;
